/**
 * ntc-barre.js — tiene le nostre barre incollate in alto, sotto alla testata del tema.
 *
 * ⛔ PERCHE' SERVE. Il tema incolla in alto SOLO la sua testata (`.section-header`): le
 * sezioni nostre sono fratelli, e scorrendo sparivano — restava il logo e la ricerca, senza
 * piu' menu ne' barra dei ricambi. Su ntc-italia.it restano invece a portata di mano.
 *
 * ⚠️ Piu' barre incollate si impilano solo se ognuna sa QUANTO E' ALTA quella sopra: qui si
 * misura la testata (e il menu grande) e si scrivono due variabili che la CSS usa come
 * scostamento. Scritte a mano sarebbero sbagliate al primo cambio di logo o di lingua.
 *
 * ⚠️ Se la testata del tema NON e' incollata (opzione spenta dal pannello), lo scostamento
 * e' zero: altrimenti le barre resterebbero sospese a mezz'aria.
 */
( function () {
  'use strict';
  if ( window.__ntcBarrePronte ) { return; }
  window.__ntcBarrePronte = true;

  var radice = document.documentElement;

  function alta( el ) {
    return el ? Math.round( el.getBoundingClientRect().height ) : 0;
  }

  function misura() {
    var testata = document.querySelector( '.section-header' );
    var menu = document.querySelector( '.section-ntc-megamenu' );
    var h = 0;
    if ( testata ) {
      var pos = getComputedStyle( testata ).position;
      if ( pos === 'sticky' || pos === 'fixed' ) { h = alta( testata ); }
    }
    radice.style.setProperty( '--ntc-h-testata', h + 'px' );
    radice.style.setProperty( '--ntc-h-menu', alta( menu ) + 'px' );
  }

  /**
   * La testata si stringe appena si scorre.
   *
   * ⛔ Ferma in cima la parte incollata e' alta 208px: su uno schermo da 900 se ne mangia
   * quasi un quarto. Scorrendo si toglie di mezzo cio' che serve solo alla prima occhiata
   * (il telefono, l'aria attorno al logo) e restano ricerca, carrello, menu e tendine.
   *
   * ⚠️ DUE SOGLIE, non una. Con una sola, chi si ferma proprio sul confine vede la testata
   * aprirsi e chiudersi ad ogni pixel di scorrimento. Si stringe a 120 e si riapre a 40:
   * in mezzo non succede niente.
   * ⚠️ Dopo il cambio si RIMISURA: lo scostamento di ogni barra incollata e' l'altezza di
   * quella sopra, e se non si aggiorna le barre si sovrappongono.
   */
  var GIU = 120;
  var SU = 40;
  var stretto = false;

  function acceso() {
    var mm = document.querySelector( '[data-ntc-megamenu]' );
    return ! mm || mm.getAttribute( 'data-stringi' ) !== 'false';
  }

  function guarda() {
    if ( ! acceso() ) { return; }
    var y = window.pageYOffset || document.documentElement.scrollTop;
    if ( ! stretto && y > GIU ) { stretto = true; }
    else if ( stretto && y < SU ) { stretto = false; }
    else { return; }
    if ( stretto ) { radice.setAttribute( 'data-ntc-stretto', '1' ); }
    else { radice.removeAttribute( 'data-ntc-stretto' ); }
    // ⚠️ Le altezze cambiano con l'animazione: si rimisura a fine transizione, non subito.
    setTimeout( misura, 60 );
    setTimeout( misura, 240 );
  }

  misura();
  guarda();
  window.addEventListener( 'scroll', guarda, { passive: true } );
  window.addEventListener( 'resize', misura );
  window.addEventListener( 'load', misura );
  document.addEventListener( 'shopify:section:load', misura );

  // ⚠️ La testata cambia altezza da sola (l'avviso in alto che sparisce, il logo che si
  //    rimpicciolisce allo scorrimento): senza tenerla d'occhio, lo scostamento resta
  //    quello del primo istante e le barre si sovrappongono.
  if ( window.ResizeObserver ) {
    var t = document.querySelector( '.section-header' );
    if ( t ) { new window.ResizeObserver( misura ).observe( t ); }
  }
}() );
